import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMagic = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_58922_1933)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M8.8835 6.96191C9.06855 6.43571 9.24017 5.94465 9.41808 5.45599C9.46714 5.32122 9.50757 5.15667 9.68067 5.14119C9.89457 5.12206 9.92987 5.31849 9.98346 5.4625C10.1931 6.02579 10.3804 6.59793 10.5956 7.15888C11.3103 9.02116 12.6008 10.3079 14.394 11.0724C14.9375 11.3042 15.5015 11.4853 16.0526 11.699C16.1941 11.7538 16.3886 11.7835 16.3906 11.9927C16.3927 12.2015 16.2022 12.2365 16.0593 12.2922C15.6277 12.4605 15.1936 12.622 14.758 12.779C12.653 13.5373 11.2265 14.9904 10.4776 17.1411C10.3118 17.6171 10.1421 18.0918 9.96891 18.565C9.92463 18.686 9.87483 18.831 9.72883 18.8433C9.55258 18.858 9.48989 18.7032 9.43971 18.565C9.27887 18.1221 9.11781 17.679 8.9686 17.2318C8.20872 14.9546 6.68099 13.4792 4.47335 12.7075C4.06643 12.5652 3.66378 12.41 3.2606 12.2568C3.14014 12.2111 3.0114 12.1531 3.00078 12.0011C2.98723 11.8072 3.15308 11.7718 3.28316 11.722C3.7456 11.5447 4.21002 11.3728 4.67458 11.2014C6.69986 10.4543 8.10104 9.05536 8.8835 6.96191Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.7795 3.28033C19.3711 3.90648 20.1791 4.06972 21.0001 4.4672C20.1489 4.93267 19.3023 5.10574 18.691 5.74526C18.092 6.37192 17.902 7.20979 17.4673 8.08012C17.0442 7.21412 16.8593 6.3609 16.2397 5.73427C15.6274 5.1151 14.8016 4.93691 13.9775 4.48397C14.7995 4.03374 15.644 3.85415 16.247 3.21513C16.8378 2.58904 17.0534 1.76386 17.4694 1C17.9048 1.77301 18.0806 2.66698 18.7795 3.28033Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.0292 19.934C18.5689 20.4286 17.9785 21.6372 17.4947 23C17.0446 22.2479 16.8709 21.3883 16.2549 20.7726C15.6405 20.1585 14.8404 19.9285 14.0645 19.5284C14.7703 19.0653 15.6088 18.8871 16.2148 18.2704C16.8344 17.6398 17.0641 16.8081 17.4555 16.0144C17.8863 16.7691 18.0897 17.6127 18.6937 18.2387C19.304 18.8711 20.1311 19.0803 20.9228 19.4564C20.6475 19.7744 20.3298 19.7969 20.0292 19.934Z",
				fill: "currentColor"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_58922_1933",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 22,
			fill: "white",
			transform: "translate(3 1)"
		})
	}) })]
});
export default SvgMagic;
